import { QueryParams, TabNames } from '../types/enums';

export function getTabUrlQueryParamState(
    routerQueryString: string,
    defaultTab: TabNames,
): string {
    const params = new URLSearchParams(routerQueryString);

    const tab = params.get(QueryParams.tab)?.toLowerCase();

    // Make sure that the value of the tab query param is supported, otherwise default to the samples tab
    return tab &&
        Object.values(TabNames as { [key: string]: string }).includes(tab)
        ? tab
        : defaultTab;
}
